import { useEffect, useState } from 'react';

import { formatCoins } from '../../lib/idle/format';
import { getIdleState, onCoin } from '../../lib/idle/idleStore';
import Coin from './Coin';
import Styles from './CoinDrops.module.css';

let nextId = 0;

const LIFETIME_MS = 2300; // a hair longer than the slowest animation (the number, 2.2s)

const CoinDrops = () => {
  const [drops, setDrops] = useState([]);

  useEffect(
    () =>
      onCoin(({ amount }) => {
        if (!getIdleState().settings.coinPops) return;
        const id = ++nextId;
        const dir = Math.random() < 0.5 ? -1 : 1;
        const side = dir * (55 + Math.random() * 35); // coin lands 55-90px left or right
        const jitter = (Math.random() - 0.5) * 30; // number drifts a little off-center
        setDrops((d) => [...d.slice(-8), { id, amount, side, jitter }]);
        setTimeout(() => setDrops((d) => d.filter((x) => x.id !== id)), LIFETIME_MS);
      }),
    [],
  );

  return (
    <div className={Styles.layer} aria-hidden="true">
      {drops.map((d) => (
        <div
          key={d.id}
          className={Styles.drop}
          style={{ '--side': `${d.side}px`, '--jitter': `${d.jitter}px` }}
        >
          <span className={Styles.number}>+{formatCoins(d.amount)}</span>
          {/* X and Y are separate elements so each axis gets its own easing */}
          <span className={Styles.coinX}>
            <span className={Styles.coinY}>
              <Coin size={30} />
            </span>
          </span>
        </div>
      ))}
    </div>
  );
};

export default CoinDrops;